type FloatToCursorSettings = {
  initialXPercent: number;
  initialYPercent: number;
  minYPercent: number;
  maxYPercent: number;
  minXPercent: number;
  maxXPercent: number;
  debounceTimeout: number;
}

type CursorPosition = {
  x: number;
  y: number;
}

class FloatToCursor {
  private container: HTMLElement;
  private settings: FloatToCursorSettings = {
    initialXPercent: 50,
    initialYPercent: 50,
    minYPercent: 0,
    maxYPercent: 100,
    minXPercent: 50,
    maxXPercent: 100,
    debounceTimeout: 100
  };
  private timoutIsOver: boolean = true;

  constructor(container: HTMLElement, settings: FloatToCursorSettings) {
    this.container = container;
    this.settings = settings;

    this.addEventListeners();
  }
  
  getCursorPosition(e: MouseEvent): CursorPosition {
    const cursorPosition = {
      x: e.clientX,
      y: e.clientY
    }
    return cursorPosition;
  }

  onMouseEnterContainer(){
    this.container.addEventListener('mousemove', this.onMouseMoveOverContainer.bind(this));
    this.container.classList.remove('float-to-cursor--idle-animation')

  }

  onMouseLeaveContainer(){
    this.container.removeEventListener('mousemove', this.onMouseMoveOverContainer.bind(this));
    this.container.classList.add('float-to-cursor--idle-animation')
    this.container.style.setProperty('--float-to-cursor-x', `${this.settings.initialXPercent}%`);
    this.container.style.setProperty('--float-to-cursor-y', `${this.settings.initialYPercent}%`);
  }

  onMouseMoveOverContainer(e: MouseEvent){
    if(!this.timoutIsOver) return;
    const cursorPosition = this.getCursorPosition(e);
    const containerRect = this.container.getBoundingClientRect();
    const cursorInContainerPosition = {
      x: cursorPosition.x - containerRect.left,
      y: cursorPosition.y - containerRect.top
    }
    const cursorInContainerPercent = {
      x: (cursorInContainerPosition.x / containerRect.width) * 100,
      y: (cursorInContainerPosition.y / containerRect.height) * 100
    }
    const cursorInContainerPercentClamped = {
      x: Math.max(this.settings.minXPercent, cursorInContainerPercent.x),
      y: Math.max(this.settings.minYPercent, cursorInContainerPercent.y)
      // x: Math.max(this.settings.minXPercent, Math.min(cursorInContainerPercent.x, this.settings.maxXPercent)),
      // y: Math.max(this.settings.minYPercent, Math.min(cursorInContainerPercent.y, this.settings.maxYPercent))
    }
    this.container.style.setProperty('--float-to-cursor-x', `${cursorInContainerPercentClamped.x}%`);
    this.container.style.setProperty('--float-to-cursor-y', `${cursorInContainerPercentClamped.y}%`);
    this.timoutIsOver = false;
    setTimeout(() => {
      this.timoutIsOver = true;
    }, this.settings.debounceTimeout);
  }

  addEventListeners(){
    this.container.addEventListener('mouseenter', this.onMouseEnterContainer.bind(this));
    this.container.addEventListener('mouseleave', this.onMouseLeaveContainer.bind(this));
  }

}

export default FloatToCursor;